<div [formGroup]="timeRecordingForm">
    <div class="row mb-3 justify-content-end">
        <ng-container *ngIf="displayBillableDropdowns">
            <label
                class="col-12 col-md-2 col-form-label text-md-end text-start"
                translate="CONFIRMATION_TIMERECORDING_CONFIRM_PRESET_BILLABLE"
            >
            </label>

            <div class="col-12 col-md-3">
                <pace-core-dropdown
                    [parentForm]="timeRecordingFormChildren"
                    [(model)]="model.billablePresetModel"
                    id="billablePresetDropDown"
                    (valueChange)="onBillablePresetChange()"
                >
                </pace-core-dropdown>
            </div>
        </ng-container>
        <ng-container *ngIf="enableAfterHourCallOut && hasAnyOSREntry()">
            <div class="col-12 col-md-3 d-flex align-items-center mt-3 mt-md-0">
                <label
                    for="afterHoursCallOut"
                    class="col-form-label mb-sm-1 mb-0 me-2 text-nowrap text-end"
                    translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_AFTERHOURS_CALL_OUT"
                ></label>

                <pace-core-checkbox-input
                    [(model)]="model.afterHourCallOut"
                    id="afterHoursCallOut"
                    [parentForm]="timeRecordingFormChildren"
                    class="w-auto"
                ></pace-core-checkbox-input>
            </div>
        </ng-container>
    </div>

    <hr class="separator d-block d-lg-none" />

    <!-- MOBILE LAYOUT -->
    <div *ngIf="isMobile$ | async; else desktopTemplate">
        <div *ngFor="let timeRecEntry of model.timeRecordingEntries.value; index as $index">
            <div class="row mb-3">
                <div class="col-8">
                    <label class="col-form-label">
                        <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_TYPE_OF_WORK"></span>
                        <span class="px-1">/</span>
                        <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_ACTIVITY"></span>
                    </label>
                </div>
                <div class="col text-end">
                    <button
                        class="btn btn-warning"
                        *ngIf="shouldShowDeleteEntryButton(timeRecEntry)"
                        (click)="deleteEntry($index)"
                        [attr.aria-label]="'CONFIRMATION_TIMERECORDING_CONFIRM_DELETE_ENTRY_ARIA_LABEL' | translate"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-6" *ngIf="isGeneralEntry(timeRecEntry)">
                    <pace-core-dropdown
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.typeOfWorkModel"
                        (valueChange)="onTypeOfWorkChange($event, timeRecEntry)"
                    >
                    </pace-core-dropdown>
                </div>
                <div class="col-6" *ngIf="isLimitedEntry(timeRecEntry)">
                    <label class="col-form-label fw-normal text-start"> {{ timeRecEntry.typeOfWorkDescription }}</label>
                </div>
                <div class="col-6" *ngIf="displayActivities || displayMeansOfTransport">
                    <pace-core-dropdown
                        [parentForm]="timeRecordingFormChildren"
                        *ngIf="shouldShowActivityDropdown(timeRecEntry)"
                        [(model)]="timeRecEntry.activitiesModel"
                    >
                    </pace-core-dropdown>
                    <div class="travel-dropdown" *ngIf="displayMeansOfTransport">
                        <pace-core-dropdown
                            [parentForm]="timeRecordingFormChildren"
                            *ngIf="isLimitedEntry(timeRecEntry)"
                            [(model)]="timeRecEntry.meansOfTransport"
                            id="meansOfTravelDropDown"
                        ></pace-core-dropdown>
                    </div>
                </div>
                <div class="col-6" *ngIf="displayAdditionalTravelInfo">
                    <div class="travel-dropdown" *ngIf="displayMeansOfTransport">
                        <pace-core-dropdown
                            [parentForm]="timeRecordingFormChildren"
                            *ngIf="isLimitedEntry(timeRecEntry)"
                            [(model)]="timeRecEntry.meansOfTransport"
                            id="meansOfTravelDropDown"
                        >
                        </pace-core-dropdown>
                    </div>
                    <div class="travel-dropdown">
                        <pace-core-dropdown
                            [parentForm]="timeRecordingFormChildren"
                            *ngIf="shouldShowDestinationDropdown(timeRecEntry)"
                            [(model)]="timeRecEntry.destination"
                            id="destinationDropDown"
                        >
                        </pace-core-dropdown>
                    </div>
                </div>
            </div>
            <!-- Start date and time -->
            <div class="row mb-2">
                <div class="col-12">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"> </label>
                </div>
                <div class="col-7">
                    <pace-core-date-input
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.startDateModel"
                        (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                    >
                    </pace-core-date-input>
                </div>
                <div class="col-5">
                    <pace-core-time-input
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.startTimeModel"
                        (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                    >
                    </pace-core-time-input>
                </div>
            </div>
            <!-- End date and time -->
            <div class="row mb-2">
                <div class="col-12">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"> </label>
                </div>
                <div class="col-7">
                    <pace-core-date-input
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.endDateModel"
                        (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                    >
                    </pace-core-date-input>
                </div>
                <div class="col-5">
                    <pace-core-time-input
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.endTimeModel"
                        [dateModel]="timeRecEntry.endDateModel"
                        (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                    >
                    </pace-core-time-input>
                </div>
            </div>

            <!-- VALIDATION MESSAGES for a specific entry-->
            <div class="row mt-3">
                <ng-container *ngFor="let validationEntry of allFalsyValidationResults">
                    <div class="col-12">
                        <div
                            class="alert alert-danger"
                            role="alert"
                            *ngIf="validationEntry.showAtId === timeRecEntry.id"
                        >
                            {{ validationEntry.validationErrorMessage }}
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- ADD TRAVEL TO button for Korea -->
            <div class="row mb-3" *ngIf="displayAdditionalTravelToButton(timeRecEntry)">
                <div class="col">
                    <button
                        class="btn btn-primary float-start"
                        (click)="addTravelToEntry(timeRecEntry)"
                        translate="CONFIRMATION_TIMERECORDING_ADD_TRAVEL_TO_LABEL"
                    ></button>
                </div>
            </div>

            <!-- WARNING MESSAGES for a specific entry-->
            <div class="row" *ngIf="computedWarnings[timeRecEntry.id]?.hasAnyWarnings">
                <div class="col-12">
                    <div class="alert alert-warning" role="alert">
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_24H"
                        ></p>
                        <p
                            *ngIf="
                                computedWarnings[timeRecEntry.id]?.isGeneralEntryDurationExceeding10Hours &&
                                !computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours
                            "
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_10H"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isOvernightEntry"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_OVERNIGHT"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntryStartingWithAGapOf10HoursOrMore"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP_10H"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntriesHavingAnUnoccupiedGap"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP"
                        ></p>
                    </div>
                </div>
            </div>

            <!-- Duration -->
            <div class="row mb-2">
                <div class="col-4">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_DURATION"> </label>
                </div>
                <label class="col col-form-label fw-normal text-start" *ngIf="timeRecEntry.getFormattedDuration()"
                    >{{ timeRecEntry.getFormattedDuration() }}
                </label>
            </div>

            <!-- Billable -->
            <div class="row mb-5">
                <div class="col-4">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_BILLABLE"> </label>
                </div>
                <div class="col" *ngIf="displayBillableDropdowns">
                    <pace-core-dropdown
                        [parentForm]="timeRecordingFormChildren"
                        [(model)]="timeRecEntry.billableModel"
                        id="billableDropDown"
                        (valueChange)="onBillableChange()"
                    >
                    </pace-core-dropdown>
                </div>
            </div>

            <!-- Add new entry form section -->
            <div class="position-relative mb-5">
                <hr class="separator" />
                <button
                    (click)="displayIndexedAddNewEntryForm($index)"
                    class="add-entry-round-btn d-flex align-items-center justify-content-center rounded-circle btn btn-primary rounded-circle position-absolute start-50 top-50 translate-middle"
                    [attr.aria-label]="
                        (clickedTimeRecEntryIndex === $index && clickedTimeRecEntryIndex >= 0
                            ? 'CONFIRMATION_TIMERECORDING_CONFIRM_CANCEL_ENTRY_ARIA_LABEL'
                            : 'CONFIRMATION_TIMERECORDING_CONFIRM_ADD_ENTRY_ARIA_LABEL'
                        ) | translate
                    "
                >
                    <fa-icon
                        [icon]="clickedTimeRecEntryIndex === $index && clickedTimeRecEntryIndex >= 0 ? faTimes : faPlus"
                    ></fa-icon>
                </button>
            </div>
            <div *ngIf="clickedTimeRecEntryIndex === $index" class="col-12">
                <ng-container *ngTemplateOutlet="addNewTimeRecordEntryForm"></ng-container>
            </div>
        </div>
    </div>
    <!-- END OF MOBILE LAYOUT -->

    <!-- DESKTOP LAYOUT -->
    <ng-template #desktopTemplate>
        <div class="row">
            <div class="col-1 limited-col-width px-0"></div>
            <div class="col-6 ps-0">
                <label class="col-form-label">
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"></span>
                    <span class="px-1">/</span>
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"></span>
                </label>
            </div>
            <div class="col-4 text-center">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_DURATION"> </label>
            </div>
        </div>

        <div *ngFor="let timeRecEntry of model.timeRecordingEntries.value; index as $index">
            <div class="row mt-3">
                <div class="col-1 limited-col-width pe-0">
                    <button
                        class="btn btn-warning"
                        *ngIf="shouldShowDeleteEntryButton(timeRecEntry)"
                        (click)="deleteEntry($index)"
                        [attr.aria-label]="'CONFIRMATION_TIMERECORDING_CONFIRM_DELETE_ENTRY_ARIA_LABEL' | translate"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </div>

                <!-- Left hand section: Start / End and Type of Work -->
                <div class="col-6">
                    <!-- START DATE AND TIME -->
                    <div class="row gap-2">
                        <div class="col-5 p-0">
                            <pace-core-date-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.startDateModel"
                                (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                            >
                            </pace-core-date-input>
                        </div>
                        <div class="col-3 p-0">
                            <pace-core-time-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.startTimeModel"
                                (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                            >
                            </pace-core-time-input>
                        </div>
                        <!-- TYPE OF WORK -->
                        <div class="col p-0" *ngIf="isGeneralEntry(timeRecEntry)">
                            <pace-core-dropdown
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.typeOfWorkModel"
                                (valueChange)="onTypeOfWorkChange($event, timeRecEntry)"
                            >
                            </pace-core-dropdown>
                        </div>
                        <!-- TYPE OF WORK for TRAV -->
                        <div class="col p-0" *ngIf="isLimitedEntry(timeRecEntry)">
                            <label class="col-form-label fw-normal text-start">
                                {{ timeRecEntry.typeOfWorkDescription }}</label
                            >
                        </div>
                    </div>

                    <!-- End Date and Time-->
                    <div class="row mt-1 gap-2">
                        <div class="col-5 p-0">
                            <pace-core-date-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.endDateModel"
                                (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                            >
                            </pace-core-date-input>
                        </div>
                        <div class="col-3 p-0">
                            <pace-core-time-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.endTimeModel"
                                [dateModel]="timeRecEntry.endDateModel"
                                (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                            >
                            </pace-core-time-input>
                        </div>
                    </div>
                </div>

                <!-- Right hand section -->
                <div class="col-5">
                    <div class="row">
                        <div class="col-4" *ngIf="displayActivities || displayMeansOfTransport">
                            <!-- ACTIVITY P58-->
                            <pace-core-dropdown
                                [parentForm]="timeRecordingFormChildren"
                                *ngIf="shouldShowActivityDropdown(timeRecEntry)"
                                [(model)]="timeRecEntry.activitiesModel"
                            >
                            </pace-core-dropdown>
                            <!-- MEANS OF TRANSPORT NGMP58 (JP)-->
                            <div class="travel-dropdown" *ngIf="displayMeansOfTransport">
                                <pace-core-dropdown
                                    [parentForm]="timeRecordingFormChildren"
                                    *ngIf="isLimitedEntry(timeRecEntry)"
                                    [(model)]="timeRecEntry.meansOfTransport"
                                    id="meansOfTravelDropDown"
                                ></pace-core-dropdown>
                            </div>
                        </div>

                        <!-- ADDITIONAL TRAVEL INFO NGMAA -->
                        <div class="col-4" *ngIf="displayAdditionalTravelInfo">
                            <div class="travel-dropdown" *ngIf="displayMeansOfTransport">
                                <pace-core-dropdown
                                    [parentForm]="timeRecordingFormChildren"
                                    *ngIf="isLimitedEntry(timeRecEntry)"
                                    [(model)]="timeRecEntry.meansOfTransport"
                                    id="meansOfTravelDropDown"
                                >
                                </pace-core-dropdown>
                            </div>
                            <!-- DESTINATION -->
                            <div class="travel-dropdown">
                                <pace-core-dropdown
                                    [parentForm]="timeRecordingFormChildren"
                                    *ngIf="shouldShowDestinationDropdown(timeRecEntry)"
                                    [(model)]="timeRecEntry.destination"
                                    id="destinationDropDown"
                                >
                                </pace-core-dropdown>
                            </div>
                        </div>

                        <!-- DURATION -->
                        <div class="col-2 text-center px-0">
                            <label class="col-form-label fw-normal" *ngIf="timeRecEntry.getFormattedDuration()"
                                >{{ timeRecEntry.getFormattedDuration() }}
                            </label>
                        </div>

                        <!-- BILLABLE -->
                        <div class="col-4" *ngIf="displayBillableDropdowns">
                            <pace-core-dropdown
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.billableModel"
                                id="billableDropDown"
                                (valueChange)="onBillableChange()"
                            >
                            </pace-core-dropdown>
                        </div>
                    </div>
                </div>
            </div>

            <!-- VALIDATION MESSAGES for a specific entry-->
            <div class="row mt-3">
                <ng-container *ngFor="let validationEntry of allFalsyValidationResults">
                    <div class="col-1 limited-col-width"></div>
                    <div class="col-11 flex-lg-grow-1 ps-0">
                        <div
                            class="alert alert-danger"
                            role="alert"
                            *ngIf="validationEntry.showAtId === timeRecEntry.id"
                        >
                            {{ validationEntry.validationErrorMessage }}
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- ADD TRAVEL TO button for Korea -->
            <div class="row mb-3" *ngIf="displayAdditionalTravelToButton(timeRecEntry)">
                <div class="col-1 limited-col-width"></div>
                <div class="col ps-0">
                    <button
                        class="btn btn-primary float-start"
                        (click)="addTravelToEntry(timeRecEntry)"
                        translate="CONFIRMATION_TIMERECORDING_ADD_TRAVEL_TO_LABEL"
                    ></button>
                </div>
            </div>

            <!-- WARNING MESSAGES for a specific entry-->
            <div class="row" *ngIf="computedWarnings[timeRecEntry.id]?.hasAnyWarnings">
                <div class="col-1 limited-col-width"></div>
                <div class="col-11 flex-lg-grow-1 ps-0">
                    <div class="alert alert-warning" role="alert">
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_24H"
                        ></p>
                        <p
                            *ngIf="
                                computedWarnings[timeRecEntry.id]?.isGeneralEntryDurationExceeding10Hours &&
                                !computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours
                            "
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_10H"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isOvernightEntry"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_OVERNIGHT"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntryStartingWithAGapOf10HoursOrMore"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP_10H"
                        ></p>
                        <p
                            *ngIf="computedWarnings[timeRecEntry.id]?.isEntriesHavingAnUnoccupiedGap"
                            translate="CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP"
                        ></p>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <!-- END OF DESKTOP LAYOUT-->
</div>

<!-- VALIDATION MESSAGES of general-->
<div class="row" *ngIf="falsyValidationResultsCommon.length > 0">
    <div class="col-12">
        <div class="alert alert-warning" role="alert">
            <p *ngFor="let validationEntry of falsyValidationResultsCommon">
                {{ validationEntry.validationErrorMessage }}
            </p>
        </div>
    </div>
</div>

<hr class="separator d-none d-lg-block" />

<!-- BUTTONS -->
<div class="row">
    <div class="col d-flex justify-content-between">
        <button
            class="btn btn-primary"
            *ngIf="!displayNewEntryForm"
            (click)="resetTimeRecording()"
            translate="CONFIRMATION_TIMERECORDING_RESET_LABEL"
        ></button>
        <button
            class="btn btn-primary d-lg-block d-none"
            *ngIf="shouldShowAddEntryButton()"
            (click)="toggleShowNewEntryForm()"
            [disabled]="disableAddNewEntryForm()"
            translate="CONFIRMATION_TIMERECORDING_ADD_ENTRY_LABEL"
        ></button>
    </div>
</div>

<!-- ADD ENTRY FORM -->
<ng-container *ngIf="displayNewEntryForm">
    <ng-container *ngTemplateOutlet="addNewTimeRecordEntryForm"></ng-container>
</ng-container>

<ng-template #addNewTimeRecordEntryForm>
    <pace-add-time-recording-entry-form
        [timeRecordingModel]="model"
        [parentForm]="timeRecordingFormChildren"
        (timeRecordingSaved)="insertEntry($event)"
        (changesDiscarded)="hideNewEntryForm()"
    >
    </pace-add-time-recording-entry-form>
</ng-template>

<pace-time-sheet-entries
    *ngIf="otherTimeSheetEntries.length > 0"
    [otherTimeSheetEntries]="otherTimeSheetEntries"
    [model]="model"
    [enableStandbyTravel]="enableStandbyTravel"
>
</pace-time-sheet-entries>
